import { useMemo } from 'react'

import PropTypes from 'prop-types'
import { useConnect } from 'redux-bundler-hook'

import { HISTORICAL_LIMITED_DATA_DAYS } from '~/src/Flags/Tier/constants'
import createLogger from '~/src/Lib/Logging'
import { getDateTime } from '~/src/Lib/Utils'

const logger = createLogger('Tier')

export const useTier = () => {
  const { config } = useConnect('selectConfig')
  const tier = config.TIER
  return {
    tier,
    // TODO: in the mid-time that we know all the tiers, there is no way to set this if we add an unknown tier like UNLIMITED
    historicalDataDays: HISTORICAL_LIMITED_DATA_DAYS[tier === 'GO' ? 'GO' : 'DEFAULT']
  }
}

export const useAllowedTierItems = ({ items }) => {
  const { historicalDataDays } = useTier()
  const startDate = historicalDataDays ? getDateTime('now').minus({ days: historicalDataDays }).startOf('day') : null

  return useMemo(() => (
    startDate ? items.filter(item => item && getDateTime(item.timestamp) > startDate) : items
  ), [items, startDate])
}

export const Tier = ({
  children,
  ...props
}) => {
  const { hasAccess } = useTier(props)
  if (hasAccess) return children
  return null
}

Tier.PropTypes = {
  children: PropTypes.node.isRequired
}
